import {KeywordListProps} from "@/types/faq";
import React from "react";
import {addColorClass} from "@/utils/common";
import {useFaqSearch} from "@/stores/faqSearch";

export const KeywordList = (props: KeywordListProps) => {
  const {searchText} = useFaqSearch()
  return (
    <div className="uk-margin-top">
      <div className="faq-search-sub-title">
        <p className="uk-text-default uk-text-bold">
          キーワード一覧 クリックしたキーワードが検索文入力欄に追加されます。
        </p>
      </div>
      <div className="uk-margin-left uk-margin-small-top">
        <div className="uk-child-width-1-3" data-uk-grid>
          {
            [0, 1, 2].map(column => (
              <div key={column}>
                {props.faq_keyword_list?.map((item, index) => (
                  index % 3 === column &&
                  <p key={index} style={addColorClass(searchText, item.key_word)}
                     onClick={() => props.onClickKeyword(item.key_word)}>{item.key_word}</p>
                ))}
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
};